export default __webpack_public_path__ + "static/media/feel.cca8439d.svg";